import { create } from 'zustand';

interface ClassifiedExpenseUIState {
  periodo: string;
  clasificacion: string;
  agrupacion: string;
  modo: 'clasificacion' | 'agrupacion';
  cantidadMesesHistorico: number;
  searchQuery: string;

  setPeriodo: (value: string) => void;
  setClasificacion: (value: string) => void;
  setAgrupacion: (value: string) => void;
  setModo: (value: 'clasificacion' | 'agrupacion') => void;
  setCantidadMesesHistorico: (value: number) => void;
  setSearchQuery: (value: string) => void;

  reset: () => void;
}

const initialState = {
  periodo: '',
  clasificacion: '',
  agrupacion: '',
  modo: 'clasificacion' as const,
  cantidadMesesHistorico: 6,
  searchQuery: '',
};

export const useClassifiedExpenseUIStore = create<ClassifiedExpenseUIState>(set => ({
  ...initialState,

  setPeriodo: periodo => set({ periodo }),
  setClasificacion: clasificacion => set({ clasificacion }),
  setAgrupacion: agrupacion => set({ agrupacion }),
  setModo: modo => set({ modo }),
  setCantidadMesesHistorico: cantidadMesesHistorico => set({ cantidadMesesHistorico }),
  setSearchQuery: searchQuery => set({ searchQuery }),

  reset: () => set(initialState),
}));
